import { useEffect, useState } from "react";

import type { Template, TemplatesAPIResponse } from "./types";
import useFetchContract from "./use-fetch-contract";

const templateURL = "contracts/templates";

export default function useContracts() {
  const [templates, setTemplates] = useState<Template[] | null>(null);

  const [error, setError] = useState<Error | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const {
    isLoading: useFetchContractIsLoading,
    error: useFetchContractError,
    get,
  } = useFetchContract();

  useEffect(() => {
    const fetch = async () => {
      try {
        const templates = (await get(templateURL)) as TemplatesAPIResponse;
        setTemplates(templates.data);
      } catch (e) {
        if (e instanceof Error) {
          setError(e);
        }
      } finally {
        setIsLoading(false);
      }
    };

    if (!templates && !isLoading && !useFetchContractIsLoading && !error) {
      setIsLoading(true);
      fetch();
    }
  }, [templates, isLoading, useFetchContractIsLoading, error, get]);

  return {
    templates,
    isLoading: isLoading || useFetchContractIsLoading,
    error: error || useFetchContractError,
  };
}
